import React from 'react'
import "./index.css"
import { FaMap } from 'react-icons/fa6'

const MapSvg = ({onClick , activeState}) => {
    return (
        <span className={`map_icon_wrapper ${activeState ? "mapIconSvg" : ""}`}  onClick={onClick} >
            <FaMap className="map_icon_svg" />
        </span>

    )
}

export default MapSvg